import { useState, useEffect } from "react";
import {
  TableRow,
  TableCell
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { IconButton, TextField } from "@mui/material";
import moment from "moment"
import {DatePicker} from "@mui/lab";



export function EditableInvoiceRow(props) {

    const [invoice, setInvoice] = useState(props.invoice)
    const [hours, setHours] = useState(invoice.hours)
    const [bill_rate, setBillRate] = useState(invoice.invoice_type.includes("Time and Material") ? invoice.bill_rate : "")
    const [totalAmount, setTotalAmount] = useState(invoice.amount)
    const [notes, setNotes] = useState("")


    const handleNumericChange = (id, event) =>
    {
        const value = parseInt(event.target.value)
        if (!isNaN(value))
        {
            let invoice_copy = invoice
            invoice_copy[id] = value
            setInvoice(invoice_copy)
            if (id === "hours")
                setHours(value)
            else if (id === "bill_rate")
                setBillRate(value)
            else if (id === "amount")
                setTotalAmount(value)
        }
        console.log(invoice)
    }

    const onChangeDueDateHandler=(event)=>{
        setInvoice({...invoice, due_date: event.format('YYYY-MM-DD').toString()})
    }

    useEffect(function ()
    {
        if (!isNaN(parseInt(bill_rate)) && !isNaN(parseInt(hours)))
        {
            setInvoice({...invoice, amount: parseInt(invoice.bill_rate) * parseInt(invoice.hours)})
            setTotalAmount(parseInt(bill_rate) * parseInt(hours))
        }
    }, [hours, bill_rate])

    useEffect(function ()
    {
        setInvoice({...invoice, notes: notes})
    }, [notes])

    return (
    <>
        <TableRow alternate>
            <TableCell align = "center">
                {`${invoice.first_name} ${invoice.last_name}`}
            </TableCell >
            <TableCell align = "center">{invoice.client}</TableCell>
            <TableCell align = "center">
                {moment
                .utc(props.invoice.transaction_date)
                .format("YYYY-MM-DD")
                .toString()}
            </TableCell>
            <TableCell align = "center">
                <DatePicker 
                    fullWidth
                    label="Due Date"
                    required
                    value={moment.utc(invoice.due_date).format("YYYY-MM-DD")}
                    onChange={(event) => {onChangeDueDateHandler(event)}}
                    renderInput={(params)=><TextField fullWidth {...params}/>}/>
            </TableCell>
            <TableCell align = "center">
                <TextField
                helperText={"Hours"}
                value={hours}
                error={!hours}
                required
                sx={{width:'100%', margin:0}}
                inputProps={{style: {fontSize: '0.875rem'}}} // font size of input text
                    InputLabelProps={{style: {fontSize: '0.875rem'}}} 
                onChange={(event) => {event.preventDefault(); handleNumericChange("hours", event)}}
                variant="standard"
                ></TextField>
            </TableCell>
            {invoice.invoice_type.includes("Time and Material") ?
            <TableCell align = "center">
                <TextField
                helperText={"Bill Rate"}
                value={bill_rate}
                error={!bill_rate}
                required
                sx={{width:'100%', margin:0}}
                inputProps={{style: {fontSize: '0.875rem'}}} // font size of input text
                    InputLabelProps={{style: {fontSize: '0.875rem'}}} 
                onChange={(event) => {handleNumericChange("bill_rate", event)}}
                variant="standard"
                ></TextField>
            </TableCell> :
            <TableCell align = "center">{props.invoice.invoice_type}</TableCell>
            }
            {invoice.invoice_type.includes("Fixed") ?
            <TableCell align = "center">
                <TextField
                helperText={"Total Amount"}
                value={totalAmount}
                error={!totalAmount}
                required
                sx={{width:'100%', margin:0}}
                inputProps={{style: {fontSize: '0.875rem'}}} // font size of input text
                    InputLabelProps={{style: {fontSize: '0.875rem'}}} 
                onChange={(event) => {handleNumericChange("amount", event)}}
                variant="standard"
                ></TextField>
            </TableCell>
            : <TableCell align = "center">{totalAmount}</TableCell>
            }
            <TableCell align = "center">{invoice.invoice_type}</TableCell>
            <TableCell margin = "auto">
                <TextField
                helperText={"Notes"}
                value={notes}
                sx={{width:'100%', margin:0}}
                inputProps={{style: {fontSize: '0.875rem'}}} // font size of input text
                    InputLabelProps={{style: {fontSize: '0.875rem'}}} 
                onChange={(event) => {setNotes(event.target.value)}}
                variant="standard"
                ></TextField>
            </TableCell>
            <TableCell>
                <IconButton sx={{ marginLeft: 5 }} onClick={(e) => {e.preventDefault(); props.handleEdit(invoice); props.setEditInvoice(false);}}>
                    <SaveIcon/>
                </IconButton>
            </TableCell>
        </TableRow>
    </>
    );
}